export function areWholeNumberValues(values = []) {
  if (!values.length) return true;
  return values.every((value) => {
    const num = Number(value);
    return Number.isFinite(num) && Math.abs(num - Math.round(num)) < 0.0001;
  });
}

export function formatDurationSeconds(value) {
  const total = Math.max(0, Math.round(Number(value) || 0));
  const hours = Math.floor(total / 3600);
  if (hours > 0) {
    const minutes = Math.floor((total % 3600) / 60);
    const seconds = total % 60;
    return `${hours}h ${minutes}m ${seconds}s`;
  }
  const minutes = Math.floor(total / 60);
  const seconds = total % 60;
  return `${minutes}m ${seconds}s`;
}

export function formatChartTickValue(value) {
  const num = Number(value);
  if (!Number.isFinite(num)) return '';
  if (Math.abs(num - Math.round(num)) < 0.0001) {
    return String(Math.round(num));
  }
  return num.toLocaleString(undefined, { maximumFractionDigits: 1 });
}

export function resolveBarChartWidth(categoryCount = 1, longestLabelLength = 0, seriesCount = 1) {
  const slots = Math.max(categoryCount, 1);
  const baseSlot = Math.max(104, longestLabelLength * 7 + 28);
  const seriesAdjustedSlot = seriesCount > 2
    ? Math.max(baseSlot, seriesCount * 28 + 24)
    : baseSlot;
  return Math.max(320, slots * seriesAdjustedSlot);
}

export function sortChartResultByValue(result, direction) {
  if (!result || !['asc', 'desc'].includes(direction)) return result;

  const categories = result.categories;
  const series = result.series || [];
  const primaryData = series[0]?.data || [];
  const categoryCount = Array.isArray(categories)
    ? categories.length
    : primaryData.length;
  if (categoryCount < 2 || primaryData.length !== categoryCount) return result;

  const indices = Array.from({ length: categoryCount }, (_, index) => index);
  indices.sort((left, right) => {
    const leftValue = Number(Array.isArray(primaryData[left]) ? primaryData[left][1] : primaryData[left]?.y ?? primaryData[left]);
    const rightValue = Number(Array.isArray(primaryData[right]) ? primaryData[right][1] : primaryData[right]?.y ?? primaryData[right]);
    const normalizedLeft = Number.isFinite(leftValue) ? leftValue : Number.NEGATIVE_INFINITY;
    const normalizedRight = Number.isFinite(rightValue) ? rightValue : Number.NEGATIVE_INFINITY;
    return direction === 'desc'
      ? normalizedRight - normalizedLeft || left - right
      : normalizedLeft - normalizedRight || left - right;
  });

  return {
    ...result,
    ...(Array.isArray(categories)
      ? { categories: indices.map((index) => categories[index]) }
      : {}),
    series: series.map((item) => ({
      ...item,
      data: indices.map((index) => item.data[index]),
    })),
  };
}

const SHORT_MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

export function formatChartDateLabel(value) {
  if (value == null) return '';
  const text = String(value);
  const match = text.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!match) return text;
  const month = Number(match[2]);
  const day = Number(match[3]);
  if (month < 1 || month > 12 || day < 1 || day > 31) return text;
  return `${day} ${SHORT_MONTHS[month - 1]}`;
}

export default formatChartTickValue;
